import { render, staticRenderFns } from "./RecSidebarMobile.vue?vue&type=template&id=c18164ec&"
import script from "./RecSidebarMobile.vue?vue&type=script&lang=js&"
export * from "./RecSidebarMobile.vue?vue&type=script&lang=js&"
import style0 from "./RecSidebarMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports